/**
 * The run's game clock: it starts at 06:00 and runs an in-game hour every
 * `GAME_SECONDS_PER_HOUR` seconds. The HUD's publisher and the night
 * vignette both read the hour from here.
 */

/** In-game seconds per in-game hour (the HUD's clock only changes by the hour). */
export const GAME_SECONDS_PER_HOUR = 10;
/** The hour a run starts at. */
const START_HOUR = 6;
/** Night runs from this hour... */
const NIGHT_START_HOUR = 20;
/** ...to this one. */
const NIGHT_END_HOUR = 6;

/** The hour of the day (0-23) at this game time. */
export function resolveGameHour(gameTimeSec: number): number {
    return (START_HOUR + Math.floor(gameTimeSec / GAME_SECONDS_PER_HOUR)) % 24;
}

/** Whether it is night (20:00 to 06:00) at this game time. */
export function isNightAt(gameTimeSec: number): boolean {
    const hour = resolveGameHour(gameTimeSec);
    return hour >= NIGHT_START_HOUR || hour < NIGHT_END_HOUR;
}
